__webpack_require__.p = "/getting-started-reversed-guard/account-setup/";